import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageShell from './PageShell';
import Seo from '../components/Seo';
import { useI18n } from '../context/I18nContext';
import { publicApi } from '../api';
import { useApi } from '../hooks/useApi';
import { Spinner, EmptyState } from '../components/StateHelpers';
import { ArrowRight, Calendar, Tag as TagIcon, GitCommit } from 'lucide-react';

export default function Updates() {
  const { lang, tr } = useI18n();
  const { data, loading } = useApi(() => publicApi.updates(lang), [lang]);
  useEffect(() => { document.title = 'Güncellemeler — Aegis Studios'; }, []);
  const items = (data || []).slice().sort((a, b) => {
    if (a.created_at && b.created_at) {
      return new Date(b.created_at) - new Date(a.created_at);
    }
    return (Number(b.id) || 0) - (Number(a.id) || 0);
  });

  return (
    <PageShell eyebrow={tr('updates.eyebrow', 'GÜNCELLEMELER')} title={<><span className="text-white">{tr('updates.title1', 'Sürüm')} </span><span className="gold-text">{tr('updates.title2', 'Notları')}</span></>} subtitle={tr('updates.subtitle', 'Aegis Studios projelerinin gelişim günlüğü.')}>
      <Seo title={tr('updates.title2', 'Sürüm Notları')} />
      <section className="pb-24">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 lg:px-10">
          {loading ? <Spinner /> : items.length === 0 ? (
            <EmptyState icon={GitCommit} title="Henüz güncelleme yok" />
          ) : (
            <div className="relative">
              <div className="absolute top-0 bottom-0 left-6 md:left-12 w-[1px] bg-gradient-to-b from-transparent via-[#e4b44e]/40 to-transparent" />
              <div className="space-y-6">
                {items.map((u) => (
                  <article key={u.id} className="relative pl-16 md:pl-24 group">
                    <div className="absolute left-3 md:left-9 top-4 w-7 h-7 rounded-full bg-[#0f0e12] border-2 border-[#e4b44e]/40 group-hover:border-[#f4d896] flex items-center justify-center transition">
                      <GitCommit className="w-3.5 h-3.5 text-[#f4d896]" />
                    </div>
                    <Link to={`/updates/${u.slug}`} className="block rounded-2xl border border-white/8 bg-gradient-to-b from-[#111015] to-[#0a090c] hover:border-[#e4b44e]/40 transition p-6 md:p-8 card-hover">
                      <div className="flex flex-wrap items-center gap-3 mb-3 text-xs">
                        {u.version && <span className="px-2 py-1 rounded bg-[#e4b44e]/15 border border-[#e4b44e]/30 text-[#f4d896] font-bold tracking-wider">v{u.version}</span>}
                        {u.project_name && <span className="px-2 py-1 rounded bg-white/5 border border-white/10 text-white/60 tracking-wider inline-flex items-center gap-1.5"><TagIcon className="w-3 h-3" /> {u.project_name}</span>}
                        {u.created_at && <span className="text-white/40 tracking-widest inline-flex items-center gap-1.5"><Calendar className="w-3 h-3" /> {String(u.created_at).slice(0, 10)}</span>}
                      </div>
                      <h3 className="font-display text-xl md:text-2xl font-bold text-white leading-tight mb-3 group-hover:gold-text transition">{u.title}</h3>
                      {u.summary && <p className="text-white/60 line-clamp-2">{u.summary}</p>}
                      <div className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold tracking-widest text-[#e4b44e]/90 group-hover:text-[#f4d896] transition">
                        DEVAMINI OKU <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition" />
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
    </PageShell>
  );
}
